import React from 'react';

import { Text } from '@change/ds-core-ui';
import { TextField } from '@change/ds-forms';

export const EntryField: React.FC<Props> = ({ name, title, subtitle, label, placeholder, onBlur }) => {
	return (
		<div className="flex w-full flex-col gap-4">
			<div>
				<Text as="h2" fontWeight="bold" variant="heading" size="x-small">
					{title}
				</Text>
				<Text as="p" size="small" className="text-typography-weak">
					{subtitle}
				</Text>
			</div>

			<TextField
				name={name}
				data-qa={`${name}-input`}
				label={label}
				inputElementType="textarea"
				size="large"
				labelIsVisible={false}
				maxLength={500}
				placeholder={placeholder}
				onBlur={onBlur}
				inputOptions={{ className: 'bg-white' }}
			/>
		</div>
	);
};

type Props = {
	name: string;
	title: string;
	subtitle: string;
	label: string;
	placeholder?: string;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};
